import { m } from '@aimfora/i18n'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'
import { z } from 'zod'
import { ClassManagement } from '~/components/class-management'

export const Route = createFileRoute('/_authed/app/classes')({
  validateSearch: z.object({ klasse: z.string().optional() }),
  head: () => ({ meta: [{ title: `${m.classes_title()} – ${m.app_name()}` }] }),
  component: ClassesPage,
})

function ClassesPage() {
  const { klasse } = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSelect = useCallback(
    (id: string | undefined) => void navigate({ search: { klasse: id }, replace: true }),
    [navigate],
  )
  return <ClassManagement selectedId={klasse} onSelect={onSelect} />
}
